import { ReactComponent as StartingIcon } from '../../images/icons/starting-icon.svg';
import { ReactComponent as CalendarIcon } from '../../images/icons/calendar-icon.svg';
import { ReactComponent as ShoppingIcon } from '../../images/icons/shopping-bag-icon.svg';
import { ReactComponent as TrainingIcon } from '../../images/icons/training-icon.svg';
import { ReactComponent as WalletIcon } from '../../images/icons/wallet-icon.svg';
import { ReactComponent as HomeIcon } from '../../images/icons/home-icon.svg';
import { ReactComponent as TeamIcon } from '../../images/icons/team-icon.svg';
import { useSelector } from 'react-redux';

export const BUSINESS_PURPOSE_DATA = [
    {
        id: 'p1',
        title: "I'm new and just starting out in business",
        handle: 1,
        icon: <StartingIcon />,
    },
    {
        id: 'p2',
        title: "I'm already established and browsing  for a new booking & consent software",
        handle: 2,
        icon: <CalendarIcon />,
    },
    {
        id: 'p3',
        title: 'Purchasing prescription & non-prescription products',
        handle: 3,
        icon: <ShoppingIcon />,
    },
    {
        id: 'p4',
        title: "I'm a training provider and want to manage students and courses",
        handle: 4,
        icon: <TrainingIcon />,
    },
    {
        id: 'p5',
        title: 'I would like to offer my clients payment plans and finance options',
        handle: 5,
        icon: <WalletIcon />,
    },
    {
        id: 'p6',
        title: 'I own a premises and people rent space in my clinic or salon',
        handle: 6,
        icon: <HomeIcon />,
    },
];

export const BUSINESS_SIZE_DATA = [
    {
        id: 's1',
        title: 'Solo-entrepreneur (just me)',
        handle: 'solo',
        icon: <StartingIcon />,
    },
    {
        id: 's2',
        title: 'Small team  1-3 memebers of staff',
        handle: 'small-team',
        icon: <TeamIcon />,
    },
    {
        id: 's3',
        title: 'Medium size team 3-5 staff',
        handle: 'medium-team',
        icon: <ShoppingIcon />,
    },
    {
        id: 's4',
        title: 'Large size team 5+ staff',
        handle: 'large-team',
        icon: <ShoppingIcon />,
    },
    {
        id: 's5',
        title: 'I have multiple locations & multiple members of staff',
        handle: 'multiple-location',
        icon: <WalletIcon />,
    },
    {
        id: 's6',
        title: "I'm a training provider",
        handle: 'training-provided',
        icon: <TrainingIcon />,
    },
];

export const API_REQUEST_TYPE = {
    occupation: 'occupation',
    industry: 'industry',
    step: {
        selectIndustry: 1,
        businessDetails: 2,
        businessPurpose: 3,
        businessSize: 4,
    },
    ALL_STEPS_COMPLETED: 4
};

export const IsStepNotAccessible = (step) => {
    const { preOnboardingStep } = useSelector((state) => state?.GetPreonboardingReducer);
    return preOnboardingStep < step - 1 && preOnboardingStep !== API_REQUEST_TYPE.ALL_STEPS_COMPLETED;
};
